<ion-card class="card-shadow-7"
style="border-radius: 0.5em;height: 100%;padding: 0.2em;"
>

<ion-grid class="ion-no-padding" >
<ion-row  >
  <ion-col style="padding: 0.4em;" size="8">
    <ion-label class="paragraph-input-fields-bold">{{('keys.data.violations.ticket' | translate : {Default:'Ticket'}) || 'Ticket'}} #{{violation['Ticket']}}</ion-label>
  </ion-col>
  <ion-col size="4" style="text-align: center;">
    <ion-chip style="padding: 0.5em;"
    color="success"
    *ngIf="violation['timeLeft'] && violation.appealType !== appealsSRV.appealTypes.cancelled"
  >
    <ion-label
      class="ion-text-wrap"
      *ngIf="violation['timeLeft']['days']>0"
      >{{violation['timeLeft']['days']}} days left</ion-label
    >
    <ion-label
      class="ion-text-wrap"
      *ngIf="violation['timeLeft']['days']<=0 && violation['timeLeft']['hours']>0 "
      >{{violation['timeLeft']['hours']}} hours
      left</ion-label
    >
    <ion-label
      class="ion-text-wrap"
      *ngIf="violation['timeLeft']['days']<=0 && violation['timeLeft']['hours']<=0 "
      >{{violation['timeLeft']['minutes']}} minutes
      left</ion-label
    ></ion-chip
  >
  <ion-chip *ngIf="!violation['timeLeft']" color="danger"
          ><ion-label>Past Due</ion-label>
        </ion-chip>
  </ion-col>
</ion-row>
<ion-row *ngIf="violation['Plate']!=''">
<ion-col>
  <ion-item lines="none">
    <ion-label class="paragraph-input-fields-regular" slot="start" style="font-weight: bold;">Plate</ion-label>
    <ion-label style="text-align: right;">{{violation.Plate}}</ion-label>
  </ion-item>
  
</ion-col>
</ion-row>
<ion-row>
<ion-col>
  <ion-item
  lines="none"
  *ngFor="let detail of violation['details'];"
>
  <ion-label class="ion-text-wrap" 
    >{{detail.ViolationDescr}}</ion-label
  >
  <span  style="color: var(--ion-color-danger)"
    [ngStyle]="{'text-decoration':appealsSRV.isCancelled(violation.appealType)}"
    class="ion-text-wrap paragraph-input-fields-regular ion-text-right"
    >{{detail.offenceFine | currency}}</span
  >
</ion-item>
              
</ion-col>
</ion-row>
<ion-row>
<ion-col>
  <ion-item lines="none">
    <ion-label class="ion-text-wrap" 
      >Adjustment</ion-label
    >
    <ion-label class="ion-text-wrap paragraph-input-fields-regular ion-text-right"
      >{{violation.CalculatedFine.adjustment |
      currency}}</ion-label
    >
  </ion-item>
  
</ion-col>
</ion-row>
<ion-row>
<ion-col>
  <ion-item
    lines="none"
  >
    <ion-label class="ion-text-wrap paragraph-input-fields-bold" 
      >Total</ion-label
    >
    <ion-label
      class="ion-text-wrap paragraph-input-fields-bold ion-text-right"
    >
      {{violation.CalculatedFine.finalTotal |
      currency}}</ion-label
    >
  </ion-item>
</ion-col>
</ion-row>
<ion-row>
<ion-col>
  <ion-button
  (click)="appealsSRV.openViolationInfoModal(violation)"
  expand="block"
  fill="clear"
  color="secondary"
  >More info
  <ion-badge class="ion-text-wrap"
color="success"
*ngIf="violation.payID && violation.appealType !== appealsSRV.appealTypes.cancelled"
>{{ ('keys.data.violations.already_paid' | translate : {Default:'Already Paid'} )
||"Already Paid"}}</ion-badge
></ion-button>
</ion-col>
</ion-row>
</ion-grid>

 </ion-card>
